import gql from "graphql-tag";
import {
  Article,
  ArticleCategory,
  ArticleSource,
  Distributor,
  Footprint,
  Location,
  ProductGroup,
} from "../../api/schema";

export interface _Article_ArticleSource_Response {
  id: number;
  name: string;
  footprint: Footprint;
  location: Location;
  sources: Array<ArticleSource>;
  datasheet_url: string | null;
  picture: string | null;
  product_group: ProductGroup;
  article_category: ArticleCategory;
}

export interface ArticleSourceViewResponse {
  articles: Array<Article>;
  distributors: Array<Distributor>;
}

export const ArticleSourceViewQuery = gql`
  query articleSourceviewQuery {
    articles {
      id
      name
      datasheet_url
      picture
      footprint {
        id
        name
        type
      }
      location {
        id
        name
        parent {
          id
          name
        }
      }
      sources {
        id
        order_number
        url
        moq
        quantity_scale
        distributor {
          id
          name
          short_name
          search_url
        }
      }
      product_group {
        id
        name
        parent {
          id
          name
          parent {
            id
            name
          }
        }
      }
      article_category {
        id
        name
      }
    }
    distributors {
      id
      name
      short_name
      search_url
    }
  }
`;

export interface CreateArticleSourceResponse {
  createArticleSource: { id: number };
}

export interface UpdateArticleSourceResponse {
  updateArticleSource: { id: number };
}

export interface DeleteArticleSourceResponse {
  deleteArticleSource: { id: number };
}

export const CreateArticleSourceMutation = gql`
  mutation createArticleSource($values: CreateArticleSourceInput!) {
    createArticleSource(values: $values) {
      id
    }
  }
`;

export const UpdateArticleSourceMutation = gql`
  mutation updateArticleSource($values: UpdateArticleSourceInput!) {
    updateArticleSource(values: $values) {
      id
    }
  }
`;

export const DeleteArticleSourceMutation = gql`
  mutation deleteArticleSource($id: ID!) {
    deleteArticleSource(id: $id)
  }
`;
